import { useCallback, useEffect, useState } from 'react';
import { AvailableStores, GoodsSupplyCase, StoreStockData } from 'common/components/stocks-in-stores/types';

export const useStocksLogic = (
  stores: AvailableStores,
  stocks: StoreStockData[],
  supplyCase: GoodsSupplyCase,
  onStocklistShow: () => void,
) => {
  const onlyOnlineCase = supplyCase === 'CASE_7';
  const itHasStocksRecords = stocks.length > 0;
  const [availableStore, setAvailableStore] = useState<StoreStockData | null>(null);
  const [isSingleStoreInRegion, setIsSingleStoreInRegion] = useState(false);

  useEffect(() => {
    if (!availableStore) {
      setAvailableStore(stocks[0]);
    }
  }, [availableStore, stocks]);

  useEffect(() => {
    if (stores && availableStore) {
      const currentRegionStores = stores.filter((store) => store.id === availableStore.storeCode);
      setIsSingleStoreInRegion(
        currentRegionStores.length === 1 && currentRegionStores.length === stocks.length,
      );
    }
  }, [availableStore, stocks.length, stores]);

  const showInteractiveTitle = itHasStocksRecords && !isSingleStoreInRegion;
  const showNonInteractiveTitle = !onlyOnlineCase && isSingleStoreInRegion;
  const stockInStoresEmpty =
    stocks.length > 0 && stocks.filter(({ stockValue }) => stockValue > 0).length === 0;
  const stockEmptyDisplayAvailable =
    stockInStoresEmpty && stocks.filter(({ displaySample }) => !!displaySample).length > 0;

  const onStocklistShowDispatch = useCallback(() => {
    onStocklistShow?.();
  }, [onStocklistShow]);

  return {
    showInteractiveTitle,
    showNonInteractiveTitle,
    stockInStoresEmpty,
    stockEmptyDisplayAvailable,
    availableStore,
    onStocklistShowDispatch,
  };
};
